import PropTypes from 'prop-types';
import React from 'react';
import Swipeable from 'react-swipeable';
import { forEach as _forEach } from 'lodash';

import { src } from 'utils/imgix';

import { ResponsiveImage } from 'sheets';

import styles from './Gallery.css';

const Gallery = (props) => {
  const buildImage = (data, key) => {
    const isActive = props.selectedOption === key;
    const imgClass = (isActive ? styles[`slide-image-active`] : styles[`slide-image`]);
    const imgConfig = {
      path: data.image_path,
      sizes: `(min-width: 1846px) 1200px, (min-width: 1280px) 65vw, (min-width: 1024px) 60vw, 100vw`,
      min: 320,
      max: 1200,
    };

    return (
      <ResponsiveImage
        className={imgClass}
        config={imgConfig}
        description={data.image_alt}
        key={key}
      />
    );
  };

  const renderImages = (variants) => {
    const images = [];

    _forEach(variants, (value, key) => {
      if (value) {
        images.push(buildImage(value, key));
      }
    });

    return images;
  };

  const getPreviousKey = (currentKey, keys) => {
    const previousIndex = keys.indexOf(currentKey) - 1;
    if (previousIndex < 0) {
      return keys[keys.length - 1];
    }

    return keys[previousIndex];
  };

  const getNextKey = (currentKey, keys) => {
    const nextIndex = keys.indexOf(currentKey) + 1;
    if (nextIndex > keys.length - 1) {
      return keys[0];
    }

    return keys[nextIndex];
  };

  const buildSlide = (data, key) => {
    const isActive = props.selectedSlide === key;
    const galleryClass = (isActive ? styles[`slide--${data.position}-active`] : styles[`slide--${data.position}`]);
    const galleryArray = Object.keys(props.galleryData).filter((filterKey) => {
      return !!props.galleryData[filterKey];
    });

    const iterateNextSlide = () => {
      const nextKey = getNextKey(props.selectedSlide, galleryArray);
      props.onClick(nextKey, galleryArray.indexOf(nextKey));
    };
    const iteratePrevSlide = () => {
      const previousKey = getPreviousKey(props.selectedSlide, galleryArray);
      props.onClick(previousKey, galleryArray.indexOf(previousKey));
    };

    return (
      <Swipeable
        className={galleryClass}
        key={key}
        onClick={iterateNextSlide}
        onSwipedLeft={iterateNextSlide}
        onSwipedRight={iteratePrevSlide}
      >
        {renderImages(data.variants)}
      </Swipeable>
    );
  };

  const renderSlides = () => {
    const slides = [];

    _forEach(props.galleryData, (value, key) => {
      if (value) {
        slides.push(buildSlide(value, key));
      }
    });

    return slides;
  };

  const buildThumbnailImage = (data, key) => {
    const isActive = props.selectedOption === key;
    const imgClass = (isActive ? styles[`thumbnail-image-active`] : styles[`thumbnail-image`]);

    return (
      <img
        alt={data.image_alt}
        className={imgClass}
        key={key}
        src={src(data.thumbnail_path, 100)}
      />
    );
  };

  const renderThumbnailImages = (variants) => {
    const images = [];

    _forEach(variants, (value, key) => {
      if (value) {
        images.push(buildThumbnailImage(value, key));
      }
    });

    return images;
  };

  const buildThumbnail = (data, key) => {
    const isActive = props.selectedSlide === key;
    const dotClass = (isActive ? styles[`thumbnail-dot-active`] : styles[`thumbnail-dot`]);
    const thumbnailClass = (isActive ? styles[`thumbnail-active`] : styles[`thumbnail`]);
    const galleryArray = Object.keys(props.galleryData).filter((filterKey) => {
      return !!props.galleryData[filterKey];
    });

    return (
      <button
        className={thumbnailClass}
        key={key}
        onClick={props.onClick.bind(this, key, galleryArray.indexOf(key))}
      >
        <div className={dotClass} />
        {renderThumbnailImages(data.variants)}
      </button>
    );
  };

  const renderThumbnails = () => {
    const thumbnails = [];

    _forEach(props.galleryData, (value, key) => {
      if (value) {
        thumbnails.push(buildThumbnail(value, key));
      }
    });

    return thumbnails;
  };

  return (
    <div className={styles.container}>
      <div className={styles[`slides`]}>
        {renderSlides(styles)}
      </div>
      <div className={styles[`thumbnails`]}>
        {renderThumbnails(styles)}
      </div>
    </div>
  );
};

Gallery.propTypes = {
  galleryData: PropTypes.object.isRequired,
  selectedOption: PropTypes.string.isRequired,
  selectedSlide: PropTypes.string.isRequired,
};

export default Gallery;
